import React, { useState } from "react";
import { useParams } from "react-router-dom";
import KLHeader from "../../../components/KLHeader";
import KLButton from "../../../components/KLButton";
import KLPleaseWait from "../../../components/KLPleaseWait";
import { InfoText, Subtitle, Title } from "../../styles";
import { Actions, Container, KeepButton } from "./styles";
import { reminderActionsService } from "../../../services/reminderActionsService";
import type { ReminderAction } from "../types";
import {
  priorActionVerbHebrew,
  SERVER_ERROR_MSG,
  TOKEN_ERROR_MSG,
} from "../messages";

type ViewState =
  | { kind: "prompt" }
  | { kind: "submitting" }
  | { kind: "kept" }
  | { kind: "success" }
  | { kind: "alreadyActed"; priorAction: ReminderAction }
  | { kind: "tokenError" }
  | { kind: "serverError" };

const CancelScreen: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [state, setState] = useState<ViewState>({ kind: "prompt" });

  const handleConfirmCancel = async () => {
    if (!token) {
      setState({ kind: "tokenError" });
      return;
    }
    setState({ kind: "submitting" });
    try {
      await reminderActionsService.cancel(token);
      setState({ kind: "success" });
    } catch (err: any) {
      const status = err?.response?.status;
      const data = err?.response?.data;
      if (status === 401) {
        setState({ kind: "tokenError" });
      } else if (status === 409 && data?.prior_action) {
        setState({
          kind: "alreadyActed",
          priorAction: data.prior_action as ReminderAction,
        });
      } else {
        setState({ kind: "serverError" });
      }
    }
  };

  const handleKeep = () => setState({ kind: "kept" });

  return (
    <Container>
      <KLHeader />
      {state.kind === "prompt" && (
        <>
          <Title>לבטל את התור?</Title>
          <Subtitle>הפעולה תבטל את התור באופן סופי.</Subtitle>
          <Actions>
            <KLButton
              title="כן, בטל את התור"
              warning
              onClick={handleConfirmCancel}
            />
            <KeepButton type="button" onClick={handleKeep}>
              לא, השאירו את התור
            </KeepButton>
          </Actions>
        </>
      )}
      {state.kind === "submitting" && <KLPleaseWait text="מבטלים את התור" />}
      {state.kind === "kept" && (
        <>
          <Title>מצוין, התור נשאר.</Title>
          <InfoText>נתראה במועד המקורי.</InfoText>
        </>
      )}
      {state.kind === "success" && (
        <>
          <Title>התור בוטל. תודה שעדכנתם אותנו.</Title>
        </>
      )}
      {state.kind === "alreadyActed" && (
        <Title>{`כבר ${priorActionVerbHebrew(state.priorAction)} את התור הזה.`}</Title>
      )}
      {state.kind === "tokenError" && <Title>{TOKEN_ERROR_MSG}</Title>}
      {state.kind === "serverError" && <Title>{SERVER_ERROR_MSG}</Title>}
    </Container>
  );
};

export default CancelScreen;
